import { Outlet } from 'react-router-dom'

/**
 * M7 — Las subsecciones de Ajustes cuelgan ahora del grupo AJUSTES del
 * sidebar principal (layout/Sidebar.tsx). Este layout ya no pinta el
 * sub-sidebar de 220px: las páginas ocupan todo el ancho disponible.
 */
export default function SettingsLayout() {
  return (
    <div className="animate-slideUp">
      <Outlet />
    </div>
  )
}
